import { Thunk } from 'ha/myredux/types';
import HttpStatus from 'ha/constants/HttpStatus';

const requestGoogleLogin = (code: string): Thunk<{}, number> => (
  _,
  __,
  { apiV2 },
) => {
  return apiV2
    .googleLogin(code)
    .then(() => HttpStatus.OK)
    .catch(
      error =>
        (error.cause && error.cause.status) || HttpStatus.INTERNAL_SERVER_ERROR,
    );
};

export default requestGoogleLogin;
